import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.css']
})
export class ModelComponent implements OnInit {
    public modelId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.modelId = this.stateService.getStateParams()['model_id'];
    }

    private async loadEdit() {
        if (!!this.modelId) {
            this.edit = (await this.datatask.Post(1162, { model_id: this.modelId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1163, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    model_id: string;
    model_name: string;
    model_name_short: string;
    productionrouting_keyno: number;
    kit_type: string;
    isactive: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('model', {
//        templateUrl: 'views/components/views/model/model.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modelService', function ($stateParams, stateService, modelService) {
//            const vm = this;
//            let modelId = $stateParams.model_id;

//            vm.model = {
//                modelId: modelId,
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await modelService.getEdit({ model_id: modelId }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                modelService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            };
//        }]
//    });
//})();
